export enum AppRoute {
  // Global routes
  error = "error",
  forbidden = "forbidden",
  home = "",
  notFound = "not-found",

  // Auth routes
  login = "login",
  logout = "logout",
  forgotPassword = "forgot-password",

  // User routes
  users = "users",
  accountOverview = "users/account-overview",
  systemUsers = "users/system-users",
  userRoles = "users/user-roles",
  userDetails = "user-details", // doesn't need "users/" since this is a 3rd level route

  // My Zone routes
  myZone = "my-zone",
  dashboard = "my-zone/dashboard",
  history = "my-zone/history",
  survey = "my-zone/survey",
  // training            = 'my-zone/training',
  evaluation = "my-zone/evaluation",
  equipment = "my-zone/equipment",

  // Reports routes
  reports = "reports",
  executiveSummary = "reports/executive-summary",
  gapAssessment = "reports/gap-assessment",
  indicatorsReport = "reports/indicators-report",
  managementOverview = "reports/management-overview",
  workload = "reports/workload",
  returnOnInvestment = "reports/return-on-investment",
  activityReport = "reports/activity-report",
  assessmentResults = "reports/assessment-results",
  equipmentReport = "reports/equipment-report",

  // Training routes
  training = "training",

  // Administration routes
  administration = "admin",
  trainingAdmin = "training",
  equipmentAdmin = "equipment",
  notificationsAdmin = "notifications",
  recommendationsAdmin = "recommendations",
  assessments = "assessment-config",
  siteSettings = "site-settings",
  importDataAdmin = "import-data",
  automaticEmails = "automatic-emails",

  // Help routes
  help = "help",

  // System
  noOp = "no-op",
  unitTest = "unit-test",
}
